/* Cart drawer extras: clear the gift note when "This is a gift" is unticked. */
(function () {
  if (window.__jvCartBound) return;
  window.__jvCartBound = true;

  document.addEventListener('change', function (e) {
    var check = e.target.closest && e.target.closest('[data-jv-gift-check]');
    if (!check) return;
    var box = check.closest('.jv-gift');
    var area = box && box.querySelector('textarea');
    if (!area) return;
    if (check.checked) {
      area.focus();
    } else if (area.value) {
      area.value = '';
      area.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
